import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useContext } from 'react';
import dayjs from 'dayjs';
import { Typography, Box, Button } from '@mui/material';
import Divider from "@mui/material/Divider";
import "../../../../cssfiles/homepage.css";
import { ThemeContext } from "../../../../pages/Homepage";
import CustomButton from '../../../CommonComponents/CustomButton';
import CustomDropDown from '../../../CommonComponents/CustomDropDown';
import CustomNumberField from '../../../CommonComponents/CustomNumberField';
import {sendCommand} from '../../../../Restclient/datacollection';
import CustomCheckbox from '../../../CommonComponents/CustomCheckbox';
import CustomDialogBox from '../../../CommonComponents/CustomDialogBox';
import CustomToast from '../../../CommonComponents/CustomToast';


export default function SchedulerReadWrite(props){
    const dispatch = useDispatch();
    const{ theme }= useContext(ThemeContext);
    const userdetails = useSelector(state => state.logindata.userdetails);
    const projectname = useSelector(state => state.mainpagedata.selectedprojectname)
    const projectdetails = useSelector((state) => state.logindata.projectdata);

    const livedata = useSelector((state) => state.mainpagedata.livedata)

    const [tableHead, setTableHead] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [deviceListProps, setDeviceListProps] = useState([])
    const [gatewayId, setGatewayId] = useState([]);
    const [conn, setConn] = useState([]);
    const [newValues, setNewValues] = useState([]);
    const [newValuesforprop, setNewValuesforprop] = useState([]);
    const [writeTags, setWriteTags] = useState([]);
    const [values, setValues] = useState([]); // values for read / live data
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [edit, setEdit] = useState([]);
    const [editData, setEditData] = useState([]);
    const [OGData, setOGData] = useState([]);
    const [timestamp, settimestamp] = useState();
    const [cmdSendStatus, setCmdSendStatus] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [settingParameters, setSettingParameters] = useState("");

  useEffect(() => {
    // allorggatewaylivedata(gatewaylivedatacallback);
        var deviceList = props.widgetprop.props.extended.tagprops
        setTableHead(props.widgetprop.props.extended.column_categories)
        const col_category = props.widgetprop.props.extended.column_categories
        setDeviceListProps(deviceList)
        const tagandvalues = deviceList.map(device => {
            const tags = Object.fromEntries(
                Object.entries(device.taginformationrequired).filter(([tagId, value]) => tagId !== "operation").map(([tagId, value]) => {
                const col_cat = col_category.find(category => category.column_name === tagId)
                let v = value.default_option
                if(col_cat.options_list.length>0){
                    const optvalue = col_cat.options_list.find(option => option.option === value.default_option)
                    if(optvalue){
                        v = optvalue.value
                    }
                }
                return [col_cat.column_name,{value:v,tagid_1:value.tagid_1, tagid_2:value.tagid_2}]; // read tag set
                })
            );
            return { [device.tagid]: tags }
        })
        const masterTags = Object.fromEntries(
            col_category
            .filter(col => col.column_name !== "operation")
            .map(col => {
            let v = col.default_option;

            if (col?.options_list?.length > 0) {
                const opt = col.options_list.find(option => option.option === col.default_option);
                if (opt) v = opt.value;
            }

            return [col.column_name, { value: v, tagid_1: "", tagid_2: "" }];
            })
        );
        setValues([{ master: masterTags }, ...tagandvalues]);
        
  }, []);

  useEffect(() => {
    // allorggatewaylivedata(gatewaylivedatacallback);
    if (!Array.isArray(livedata) || livedata.length === 0) return;
    setValues(prev => mergeLiveDataIntoValues(prev, livedata));
        // setValues(tagandvalues)   
  }, [livedata]);


  function mergeLiveDataIntoValues(prevValues, liveData) {
    if (!Array.isArray(prevValues) || !Array.isArray(liveData) || liveData.length === 0) {
        return prevValues;
    }

    // If same TagId appears many times, keep latest by timestamp
    const latestByTag = {};
    liveData.forEach(item => {
        if (!item || item.TagId == null) return;
        const key = String(item.TagId);
        if (!latestByTag[key] || (item.timestamp ?? 0) >= (latestByTag[key].timestamp ?? 0)) {
        latestByTag[key] = item;
        }
    });

    return prevValues.map(deviceObj => {
        const entry = Object.entries(deviceObj)[0];
        if (!entry) return deviceObj;

       const [deviceId, fieldsObj] = entry;
        if (!fieldsObj || typeof fieldsObj !== "object") return deviceObj;

        let changed = false;
        const nextFields = {};

        Object.entries(fieldsObj).forEach(([fieldKey, fieldValue]) => {
        if (!fieldValue || typeof fieldValue !== "object") {
            nextFields[fieldKey] = fieldValue;
            return;
        }

        const tag1 = fieldValue.tagid_1 != null ? String(fieldValue.tagid_1) : "";
        const live = tag1 ? latestByTag[tag1] : undefined;

        if (live) {
            nextFields[fieldKey] = { ...fieldValue, value: live.value };
            changed = true;
        } else {
            nextFields[fieldKey] = fieldValue;
        }
        });
        return changed ? { [deviceId]: nextFields } : deviceObj;
    });
  }


  function handleConfirmSetForm(){
    const deviceId = settingParameters;
    const valueToSet = newValues.find(item => Object.keys(item)[0] === deviceId)
    let result = [];
    if(valueToSet!==undefined){

        if (deviceId==="master") {
            const masterEntry =
                newValues.find(item => Object.keys(item)[0] === "master") ||
                values.find(item => Object.keys(item)[0] === "master")
            const masterFields = masterEntry?.master || {};

            result = selectedDevices
                .filter(selDeviceId => selDeviceId && selDeviceId !== "master")
                .map(selDeviceId => {
                    const deviceEntry = values.find(item => Object.keys(item)[0] === selDeviceId);
                    const deviceFields = deviceEntry?.[selDeviceId] || {};

                    const tagValueMap = Object.fromEntries(
                        Object.entries(deviceFields)
                            .filter(([columnName, deviceMeta]) =>
                                deviceMeta &&
                                deviceMeta.tagid_2 !== "" &&
                                masterFields[columnName]
                            )
                            .map(([columnName, deviceMeta]) => [
                                deviceMeta.tagid_2,
                                masterFields[columnName].value
                            ])
                    );

                    return { [selDeviceId]: tagValueMap };
                })
                .filter(obj => {
                    const devId = Object.keys(obj)[0];
                    return Object.keys(obj[devId] || {}).length > 0;
                });

        }else{
            //skip tag_2 is ""
            result = [{ [Object.keys(valueToSet)[0]]: Object.fromEntries(valueToSet[deviceId] ? Object.entries(valueToSet[deviceId]).filter(([, v]) => v && v.tagid_2 !== "").map(([key, value]) => [value.tagid_2, value.value]) : []) }]
        }
        sendCommand(result,sendCommandCallback)
    }
    else{

    }
    setOpenConfirmDialog(false)
    // setEdit([]);
  }

  function handleSetForm(val, deviceId){
    if(deviceId==="master"){
        if(selectedDevices.length === 0){
            setOpenDialog(true);
        }else{
            setOpenConfirmDialog(true);
            setSettingParameters(deviceId)
        }
    }else{
        setOpenConfirmDialog(true);
        setSettingParameters(deviceId)
    }

    // const valueToSet = newValues.find(item => Object.keys(item)[0] === deviceId)
    // let result = [];
    // if(valueToSet!==undefined){

    //     if (deviceId==="master") {
    //         const masterEntry =
    //             newValues.find(item => Object.keys(item)[0] === "master") ||
    //             values.find(item => Object.keys(item)[0] === "master")
    //         const masterFields = masterEntry?.master || {};

    //         result = selectedDevices
    //             .filter(selDeviceId => selDeviceId && selDeviceId !== "master")
    //             .map(selDeviceId => {
    //                 const deviceEntry = values.find(item => Object.keys(item)[0] === selDeviceId);
    //                 const deviceFields = deviceEntry?.[selDeviceId] || {};

    //                 const tagValueMap = Object.fromEntries(
    //                     Object.entries(deviceFields)
    //                         .filter(([columnName, deviceMeta]) =>
    //                             deviceMeta &&
    //                             deviceMeta.tagid_2 !== "" &&
    //                             masterFields[columnName]
    //                         )
    //                         .map(([columnName, deviceMeta]) => [
    //                             deviceMeta.tagid_2,
    //                             masterFields[columnName].value
    //                         ])
    //                 );

    //                 return { [selDeviceId]: tagValueMap };
    //             })
    //             .filter(obj => {
    //                 const devId = Object.keys(obj)[0];
    //                 return Object.keys(obj[devId] || {}).length > 0;
    //             });

    //     }else{
    //         //skip tag_2 is ""
    //         result = [{ [Object.keys(valueToSet)[0]]: Object.fromEntries(valueToSet[deviceId] ? Object.entries(valueToSet[deviceId]).filter(([, v]) => v && v.tagid_2 !== "").map(([key, value]) => [value.tagid_2, value.value]) : []) }]
    //     }
    //     sendCommand(result,sendCommandCallback)
    // }
    // else{

    // }
    // // setEdit([]);
  }

  function sendCommandCallback(res){
    if(res.status === 200 && res.data.type === "success"){ 
        setCmdSendStatus(1);
    }
    else{
        setCmdSendStatus(2);
    }
    setEdit([]);
    setNewValues([]);
    setOGData([]);
    setSettingParameters("");
  }

//   function handleResetForm(){
//      setEdit([]);
//      setNewValues([]);
//      setOGData([]);
//   }

  function handleCancelForm(){
     setEdit([]);
     setNewValues([]);
     setOGData([]);
  }

  function handleEditForm(deviceId){
    const ifpresent = edit.includes(deviceId);
    //add device id to edit array if not present, if present don't add duplicate 
    if (ifpresent===false) {   
        setEdit(prev => [...prev, deviceId])
    }
    const valueToSet = values.find(item => Object.keys(item)[0] === deviceId)
    setNewValues(valueToSet ? [structuredClone(valueToSet)] : [])
    setOGData(valueToSet ? [structuredClone(valueToSet)] : [])
  }

    function setChangedValues(selectedOption, deviceId, columnName) {
       if (selectedOption === undefined || selectedOption === null || !columnName) return;
        const nextVal = selectedOption;
        setNewValues((prev) => {
            const updateEntry = (deviceObj) => {
                const fields = deviceObj?.[deviceId];
                if (!fields || !fields[columnName]) return deviceObj;
                return {
                    ...deviceObj,
                    [deviceId]: {
                        ...fields,
                        [columnName]: { ...fields[columnName], value: nextVal }
                    }
                };
            };

            //exixsting entry for device id
            const idx = prev.findIndex(item => Object.keys(item)[0] === deviceId);
            if (idx !== -1) {
                return prev.map((item, i) => i === idx ? updateEntry(item) : item);
            }
            const base = values.find(item => Object.keys(item)[0] === deviceId);
            if (!base) return prev;
            return [...prev, updateEntry(base)];
        });
    }

    function onChangeCustomDropDown(val, optionsList, deviceId, columnName){
        const value = optionsList.filter(option => option.option === val)
        setChangedValues(value[0].value,deviceId,columnName)
    }



  function onClick(){
  }

  function onChange(val,deviceId,columnName){
    setChangedValues(val,deviceId,columnName)
  }

  function onClickStatusIndicator(deviceId,columnName){
    const val = getTagAndValueFromValues(newValues, deviceId,columnName);
    const v =  val?.value === 1 ? 0 : 1;
    setChangedValues(v,deviceId,columnName)
  }

    function getTagAndValueFromValues(valuesList, deviceId, columnName){ 
        const deviceEntry = valuesList.find(item => Object.keys(item)[0] === deviceId);
        if (!deviceEntry) return null;

        const deviceFields = deviceEntry[deviceId];
        if (!deviceFields || typeof deviceFields !== "object") return null;

        const field = deviceFields[columnName];
        if (!field || typeof field !== "object") return null;

        return field; // { value, tagid_1, tagid_2 }
    }


  const renderColumnContent = (head, devices, values) => {
    const device=devices.taginformationrequired
    const deviceId = devices.tagid
    if(edit.includes(deviceId)){
        if (device[head.column_name].component === "Typography") {
            return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight}}>{device[head.column_name].config.configured_value}</Typography>;
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight}}>Devices</Typography>;
        } else if (device[head.column_name].component === "CustomButton") {
            return <CustomButton /*id={assetInfo.id}*/ onClick={onClick} disabled={true} buttonText={'status'} width={'24px'} />;
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '24px'}}>Devices</Typography>;
        } else if (device[head.column_name].component === "CustomDropDown") {
            return <CustomDropDown name={device[head.column_name]} disabled={false} /*options={device[head.column_name].options_list.map((val) => val.option)}*/ options={head.options_list.map((val) => val.option)} onChange={(val,e) => onChangeCustomDropDown(val,head.options_list, deviceId,head.column_name)} defaultValue={handleCustomDropDownDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,head.options_list,newValues)} width={'248px'}/> 
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '248px'}}>{head.options_list.map((val) => val.option === head.default_option ? val.value : null)}</Typography>;
        }else if (device[head.column_name].component === "CustomNumberField") {
            return <CustomNumberField min={0} id={device} minValueLimit={16} maxValueLimit={32}  disabled={false} onChange={(val,e)=>onChange(val,deviceId,head.column_name)} defaultValue={handleCustomNumberFieldDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,newValues)} maxLength={500} width={'180px'}/>    
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '180px'}}>{head.default_option}</Typography>;   
        }else if (device[head.column_name].component === "StatusIndicator") {
            // return <Box sx={{width: '24px', height: '24px', borderRadius: '50%', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, device[head.column_name].default_option, head.options_list,newValues)}}/>    
            return <Button id={device} sx={{width: '24px', height: '24px',minWidth: '24px', borderRadius: '50%', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, device[head.column_name].default_option, head.options_list,newValues),'&:hover': {width:'26px',height:'26px', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, device[head.column_name].default_option, head.options_list,newValues)},}} onClick={()=>{onClickStatusIndicator(deviceId,head.column_name)}}/>    
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '180px'}}>{head.default_option}</Typography>;   
        }
    }else{
        if (device[head.column_name].component === "Typography") {
            return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight}}>{device[head.column_name].config.configured_value}</Typography>;
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight}}>Devices</Typography>;
        } else if (device[head.column_name].component === "CustomButton") {
            return <CustomButton /*id={assetInfo.id}*/ onClick={onClick} disabled={true} buttonText={'status'} width={'24px'} />;
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '24px'}}>Devices</Typography>;
        } else if (device[head.column_name].component === "CustomDropDown") {
            // return <CustomDropDown name={device[head.column_name]} disabled={false} options={device[head.column_name].options_list.map((val) => val.option)} onChange={(val,e) => onChangeCustomDropDown(val,e, deviceId,head.column_name)} defaultValue={handleCustomDropDownDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,head.options_list,values)} width={'248px'}/> 
            return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '248px'}}>{handleCustomDropDownDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,head.options_list,values)}</Typography>;
        }else if (device[head.column_name].component === "CustomNumberField") {
            // return <CustomNumberField min={0} id={device} minValueLimit={16} maxValueLimit={32}  disabled={false} onChange={(val,e)=>onChange(val,e,head.column_name)} defaultValue={handleCustomNumberFieldDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,values)} maxLength={500} width={'180px'}/>    
            return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '180px'}}>{handleCustomNumberFieldDefaultValue(deviceId,head.column_name,device[head.column_name].default_option,values)}</Typography>;   
        }else if (device[head.column_name].component === "StatusIndicator") {
            // return <Box sx={{width: '24px', height: '24px', borderRadius: '50%', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, device[head.column_name].default_option, head.options_list,values)}}/>    
            return <Button id={device} disabled={true} sx={{width: '24px', height: '24px',minWidth: '24px', borderRadius: '50%', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, device[head.column_name].default_option, head.options_list,values)}} onClick={()=>{onClickStatusIndicator(deviceId,head.column_name)}}/>    
            // return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight, width: '180px'}}>{head.default_option}</Typography>;   
        }
    }
    return null;
   };

   function handleStatusIndicatorValue(deviceId,columnName, defaultOption,optionsList, values){
        const val = getTagAndValueFromValues(values, deviceId,columnName);
        return  optionsList?.find(option => option.value === (val !== null ? val.value : defaultOption))?.option ?? optionsList?.find(option => option.value === defaultOption)?.option;
    }

    function handleCustomNumberFieldDefaultValue(deviceId,columnName, defaultOption,values){
        const val = getTagAndValueFromValues(values, deviceId,columnName);
        return val !== null ? val.value : defaultOption;
    }

    function handleCustomDropDownDefaultValue(deviceId,columnName, defaultOption, optionsList, values){
        const val = getTagAndValueFromValues(values, deviceId,columnName);
        return optionsList?.find(option => option.value === (val !== null ? val.value : defaultOption))?.option ?? "";
    }

  const renderMasterColumnContent = (head, devices, values) => {
    const deviceId = devices
        if (head.component === "Typography") {
            return <Typography sx={{color: props.widgetprop.props.extended.textvalue.color, fontSize: props.widgetprop.props.extended.textvalue.fontsize, fontWeight: props.widgetprop.props.extended.textvalue.fontweight}}>Master</Typography>;
        } else if (head.component === "CustomButton") {
            return <CustomButton /*id={assetInfo.id}*/ onClick={onClick} buttonText={'status'} width={'24px'} />;
        } else if (head.component === "CustomDropDown") {
            return <CustomDropDown name={head} options={head.options_list.map((val) => val.option)} onChange={(val,e) => onChangeCustomDropDown(val,head.options_list, deviceId, head.column_name)} defaultValue={handleCustomDropDownDefaultValue(deviceId, head.column_name, head.default_option, head.options_list,newValues)} width={'248px'}/> 
        }else if (head.component === "CustomNumberField") {
            return <CustomNumberField min={0} id={deviceId} onChange={(val,e) => onChange(val,deviceId, head.column_name)} defaultValue={ handleCustomNumberFieldDefaultValue(deviceId, head.column_name, head.default_option,newValues)} maxLength={500} width={'180px'}/> 
        }else if (head.component === "StatusIndicator") {
            // return <CustomNumberField min={0} id={device} onChange={onChange} defaultValue={head.default_option} maxLength={500} width={'180px'}/> 
            return <Button id={deviceId} sx={{width: '24px', height: '24px',minWidth: '24px', borderRadius: '50%', backgroundColor: handleStatusIndicatorValue(deviceId,head.column_name, head.default_option, head.options_list,newValues)}} onClick={()=>{onClickStatusIndicator(deviceId,head.column_name)}}/>    
        }
   
    return null; 
   };

   function handleSelectDevice(selected,e){
        const value = e.target.id
        if(selected === true){
            setSelectedDevices(prev => [...prev, value])
        }else{
            setSelectedDevices(prev => prev.filter(item => item !== value))
        }
   }

   function handleSelectAllDevice(selected,e){
        const value = e.target.id
        if(selected === true){
            setSelectedDevices(deviceListProps.map(device => device.tagid))
        }else{
            setSelectedDevices([])
        }
   }

    function handleToastClose() {
        setCmdSendStatus(0);
    }

    function handleConfirmCancel() {
        setOpenDialog(false);
    }


  return (
    <Box sx={{display: 'flex', flexDirection: 'column', width: '100%',height: 'calc(100%)', maxHeight: 'calc(100%)', padding: '8px', gap : '8px', overflow: 'auto',boxSizing: 'border-box'}}>
      <>
        <CustomToast openToast={cmdSendStatus!==0} type={ cmdSendStatus===1?"Success":"Error"} autoHideDuration={10000} toastText={cmdSendStatus===1?"Command Sent Successfully!":"Command Send Failed"} onClose={handleToastClose}/>
        <CustomDialogBox dialogTitle={"No Devices selected"} dialogText={"Please Select at least one device."} openDialog={openDialog} handleCloseDialog={handleConfirmCancel} handleConfirmDialog={handleConfirmCancel} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
        <CustomDialogBox dialogTitle={"Are you sure you want to set selected device" + (selectedDevices.length>1 ? "s" : "") + "?"} dialogText={"Are you sure you want to set selected device" + (selectedDevices.length>1 ? "s" : "") + "?"} openDialog={openConfirmDialog} handleCloseDialog={()=> {setOpenConfirmDialog(false);setSettingParameters("");}} handleConfirmDialog={handleConfirmSetForm} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 'calc(100%)',width: 'calc(100%)',height:'136px',minHeight: '136px',padding:'8px',justifyContent: "space-between",gap:'8px',boxSizing:'border-box',background:"var(--SecondaryBackground)"}}>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'100%'}}> 
                <Box sx={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' ,padding:'8px'}}/>
                {/* bottom half (content space) */}
                <Box sx={{ height: '50%', display: 'flex', alignItems: 'start', boxSizing: 'border-box', padding: '8px', marginTop:'0px' }}> 
                    <CustomCheckbox id={'all'} onChange={handleSelectAllDevice} checked={selectedDevices.length=== deviceListProps.length}  />
                </Box> 
            </Box>
            {edit.includes('master')===true?
                <>
                    {tableHead.map((head, index) => (
                        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'100%'}}>
                            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'50%'}}>
                                <Typography key={index} sx={{color: props.widgetprop.props.extended.textname.color, fontSize: props.widgetprop.props.extended.textname.fontsize, fontWeight: props.widgetprop.props.extended.textname.fontweight}}>
                                    {head.display_column_name}
                                </Typography>
                            </Box> 
                            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'8px',height:'50%'}}>
                                {head.column_name === "operation"?
                                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', boxSizing:'border-box', padding:'0px 0px', gap:'4px',width:'140px'}}>
                                        {edit.includes('master') ?
                                                <>
                                                    <CustomButton /*id={assetInfo.id}*/ onClick={(val) => handleSetForm(val, 'master')} buttonText={'Set'} width={'24px'} />
                                                    <CustomButton /*id={assetInfo.id}*/ onClick={handleCancelForm} buttonText={'Cancel'} width={'24px'} />
                                                </>
                                            :
                                                <>
                                                    <CustomButton  onClick={() => handleEditForm('master')} disabled={edit.length===0?false:true} buttonText={'Edit Master'} width={'24px'} />
                                                </>
                                        }
                                    </Box>
                                    :
                                    <>
                                        {renderMasterColumnContent(head, 'master', values)}
                                    </>
                                }
                            </Box> 
                        </Box>
                    ))} 
                </>
                :
                <>
                    <Box sx={{display: 'flex', flexDirection:'column', boxSizing:'border-box', height:'100%',width:'156px'}}>
                        <Box sx={{display: 'flex', boxSizing:'border-box', minHeight:'50%',height:'50%',width:'156px'}}>
                        </Box>
                        <Box sx={{display: 'flex', boxSizing:'border-box', height:'50%',width:'156px',padding:'8px',}}>
                            <CustomButton  onClick={() => handleEditForm('master')} disabled={edit.length===0?false:true} buttonText={'Edit Master'} width={'130px'} />   
                        </Box>
                    </Box>
                </>
            }
        </Box>
        </>
      {deviceListProps.map(device => (     
        <>
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 'calc(100%)',width: 'calc(100%)',height:'136px',minHeight: '136px',padding:'8px',justifyContent: "space-between",gap:'8px',boxSizing:'border-box',background:"var(--SecondaryBackground)"}}>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'100%'}}> 
                <Box sx={{ height: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}/>
                {/* bottom half (content space) */}
                <Box sx={{ height: '50%', display: 'flex', alignItems: 'start', boxSizing: 'border-box', padding: '8px',marginTop:'8px' }}> 
                    <CustomCheckbox id={device.tagid} onChange={handleSelectDevice} checked={selectedDevices.includes(device.tagid)}  />
                </Box> 
            </Box>
            {tableHead.map((head, index) => (
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'100%'}}>
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', boxSizing:'border-box', padding:'4px 0px', gap:'4px',height:'50%'}}>
                        <Typography key={index} sx={{color: props.widgetprop.props.extended.textname.color, fontSize: props.widgetprop.props.extended.textname.fontsize, fontWeight: props.widgetprop.props.extended.textname.fontweight}}>
                            {head.display_column_name}
                        </Typography>
                    </Box> 
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing:'border-box', padding:'8px',height:'50%'}}>
                        {head.column_name === "operation"?
                            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', boxSizing:'border-box', padding:'0px 0px', gap:'4px',width:'140px'}}>
                                {edit.includes(device.tagid) ?
                                        <>
                                            <CustomButton /*id={assetInfo.id}*/ onClick={(val) => handleSetForm(val, device.tagid)} disabled={false} buttonText={'Set'} width={'24px'} />
                                            <CustomButton /*id={assetInfo.id}*/ onClick={handleCancelForm} disabled={false} buttonText={'Cancel'} width={'24px'} />
                                        </>
                                    :
                                        <>
                                            <CustomButton onClick={()=>handleEditForm(device.tagid)} disabled={edit.length===0?false:true} buttonText={'Edit'} width={'24px'} />
                                        </>
                                }                            
                            </Box>
                            :
                            <>
                                {renderColumnContent(head, device,values)}
                            </>
                        }
                    </Box> 
                </Box>
            ))} 
        </Box>
        </>
      ))}
    </Box>
  );
}